import { Component, Input, OnDestroy, OnInit, ViewChildren, ChangeDetectionStrategy } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { MatExpansionPanel } from '@angular/material/expansion';
import { DTypeFormTwoColumnsTableField } from '@grupo-constant/next-dtype/form';
import { DTypeRepository, DTypeViewableCol, SelectOption } from '@grupo-constant/next-dtype/types';
import { firstValueFrom, Subject } from 'rxjs';
import { DTypeService } from '../../dtype.service';
import { LocalizePipe } from '../../../pipes/standalone/localize.pipe';
import { LocaleString } from '../../../translate/localeString.model';
import { LocalizeService } from '../../../pipes/localize.service';

@Component({
    selector: 'twocolumnstable-component',
    templateUrl: './twocolumnstable-field.component.html',
    styleUrls: ['./twocolumnstable-field.component.scss'],
    imports: [LocalizePipe],
    changeDetection: ChangeDetectionStrategy.Eager,
})
export class DtypeTwoColumnsTableFieldComponent implements OnInit, OnDestroy {
    @ViewChildren(MatExpansionPanel) panels: MatExpansionPanel;

    @Input() field: DTypeFormTwoColumnsTableField;
    @Input() isUpdate: boolean;
    @Input() useSummaryView: boolean;

    panel: number;
    oldPanel: number;
    canAddRow: boolean = true;
    rowsSave: number[] = [];
    saving: boolean = false;

    tableHeader: LocaleString[] = [];
    tableData: any[] = [];
    dtypeRepository: DTypeRepository;
    mask: string;
    sections: string[] = [];

    numberControl: FormArray = new FormArray([]);
    total: number;

    values: number[] = [];
    options: SelectOption[] = [];

    private _unsubscribeAll = new Subject<void>();


    constructor(
        private dtypeService: DTypeService,
        private localize: LocalizeService,
    ) { }

    async ngOnInit() {
        const readonlyOnUpdate = (this.field.dTypeCol as DTypeViewableCol).readonlyOnUpdate;
        if (readonlyOnUpdate && this.isUpdate) {
            this.field.readonly = true;
        }
        this.options = this.field.dTypeCol['option'];
        await this.createTableView();
        this.numberControl.valueChanges.subscribe(value => this.field.control.setValue(value));
        if (this.field.displayTotals) {
            this.total = 0;
            for (const numControl of this.numberControl.value) {
                this.total += numControl.num;
            }
        }
    }

    ngOnDestroy() {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    getControl(index: number) {
        return this.numberControl.controls[index]?.get('num');
    }

    async createTableView() {
        this.tableData = await firstValueFrom(this.dtypeService.retrieveDTypeDataCollectionByUri(this.field.masterUri));
        let valueToArray: any;
        if (this.field.control.value) {
            if (typeof this.field.control.value === 'string') {
                valueToArray = JSON.parse(this.field.control.value);
            } else {
                valueToArray = this.field.control.value;
            }
        } else {
            valueToArray = {};
        }
        for (const data of this.tableData) {
            const control = new FormGroup({
                value: new FormControl<string>(this.options.find(o => o.code === data._oid).code),
                num: new FormControl<number>(this.field.control.value ? valueToArray.find(v => v.value === data._oid)?.num
                    : this.field.defaultValue),
            });
            this.numberControl?.push(control);
        }
    }

    getValueToPrint(value: any) {
        return this.localize.transform(this.options.find(o => o.code === value._oid).value);
    }

}


